// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ActivityResultResponseRepresentationData
 */
export interface ActivityResultResponseRepresentationData {
  /**
   *
   * @type {string}
   * @memberof ActivityResultResponseRepresentationData
   */
  activityId: string
  /**
   *
   * @type {number}
   * @memberof ActivityResultResponseRepresentationData
   */
  coinsEarned: number
  /**
   *
   * @type {string}
   * @memberof ActivityResultResponseRepresentationData
   */
  lastSavedProgressionStep?: string
  /**
   *
   * @type {number}
   * @memberof ActivityResultResponseRepresentationData
   */
  progressionLessonOverride?: number | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultResponseRepresentationData
   */
  assignmentId?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultResponseRepresentationData
   */
  assignmentTaskId?: number | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultResponseRepresentationData
   */
  rewardId?: string | null
}

/**
 * Check if a given object implements the ActivityResultResponseRepresentationData interface.
 */
export function instanceOfActivityResultResponseRepresentationData(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'activityId' in value
  isInstance = isInstance && 'coinsEarned' in value

  return isInstance
}

export function ActivityResultResponseRepresentationDataFromJSON(
  json: any,
): ActivityResultResponseRepresentationData {
  return ActivityResultResponseRepresentationDataFromJSONTyped(json, false)
}

export function ActivityResultResponseRepresentationDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityResultResponseRepresentationData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activityId: json['activity_id'],
    coinsEarned: json['coins_earned'],
    lastSavedProgressionStep: !exists(json, 'last_saved_progression_step')
      ? undefined
      : json['last_saved_progression_step'],
    progressionLessonOverride: !exists(json, 'progression_lesson_override')
      ? undefined
      : json['progression_lesson_override'],
    assignmentId: !exists(json, 'assignment_id')
      ? undefined
      : json['assignment_id'],
    assignmentTaskId: !exists(json, 'assignment_task_id')
      ? undefined
      : json['assignment_task_id'],
    rewardId: !exists(json, 'reward_id') ? undefined : json['reward_id'],
  }
}

export function ActivityResultResponseRepresentationDataToJSON(
  value?: ActivityResultResponseRepresentationData | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activity_id: value.activityId,
    coins_earned: value.coinsEarned,
    last_saved_progression_step: value.lastSavedProgressionStep,
    progression_lesson_override: value.progressionLessonOverride,
    assignment_id: value.assignmentId,
    assignment_task_id: value.assignmentTaskId,
    reward_id: value.rewardId,
  }
}
